import { useSkillSyncInProgress } from "../hooks/useSkillSyncInProgress";
import {
  type SkillUpdateInstallation,
  skillUpdateStatus,
} from "../lib/skillUpdateStatus";
import { StatusPill } from "./StatusPill";
import { Text } from "./Text";

export function SkillUpdateStatus({
  installation,
  onReview,
  reviewDisabled = false,
  detailsUrl,
  inheritLink = false,
  onCheck,
  checkDisabled = false,
  checkLabel = "Check for updates",
}: {
  installation: SkillUpdateInstallation;
  onReview?: () => void;
  reviewDisabled?: boolean;
  detailsUrl?: string;
  inheritLink?: boolean;
  onCheck?: () => void;
  checkDisabled?: boolean;
  checkLabel?: string;
}) {
  const syncing = useSkillSyncInProgress(installation.syncStartedAt);
  const status = skillUpdateStatus(
    installation,
    installation.syncStartedAt !== null && !syncing
  );
  const running = status.label === "Checking" || status.label === "Updating";
  const reviewUpdate =
    status.label === "Update available" ? onReview : undefined;
  return (
    <StatusPill
      color={status.color}
      label={status.label}
      running={running}
      detailsUrl={detailsUrl}
      inheritLink={inheritLink && !reviewUpdate}
      onPress={reviewUpdate}
      disabled={running || (!!reviewUpdate && reviewDisabled)}
      triggerLabel={
        detailsUrl
          ? `${status.label}: view Git details`
          : reviewUpdate
            ? `${status.label}. Review update`
            : status.label
      }
      compactAt={
        status.label === "Update available"
          ? 112
          : status.label === "Not checked"
            ? 96
            : 86
      }
      compactIcon={
        status.label === "Error"
          ? "x"
          : status.label === "Up to date"
            ? "check"
            : status.label === "Update available"
              ? "arrow-up"
              : running
                ? "refresh-cw"
                : "circle-dashed"
      }
      action={
        onCheck
          ? { label: checkLabel, onClick: onCheck, disabled: checkDisabled }
          : undefined
      }
      detail={
        <Text variant="text-small-md" color="var(--tooltip-fg)">
          {status.label === "Error" ? "Git sync failed" : status.detail}
        </Text>
      }
    />
  );
}
